/* eslint-disable no-untranslated-string/no-untranslated-string */
import { actionsFactory, props } from '@ngneat/effects';
import { OrganizationInvitations } from '../types';

export const organizationsActions = actionsFactory('Organizations');

export const loadOrganizations = organizationsActions.create('Load Organizations');
export const loadInvitations = organizationsActions.create('Load Invitations');

export const manageInvitation = organizationsActions.create(
  'Manage Invitation',
  props<{ invitation: OrganizationInvitations; token?: string | null }>(),
);
export const manageInvitationByToken = organizationsActions.create(
  'Manage Invitation By Token',
  props<{ token: string }>(),
);
export const manageInvitationRedirect = organizationsActions.create(
  'Handle Invitation Redirect',
  props<{ isNewUser: boolean; email: string }>(),
);
export const manageInvitationError = organizationsActions.create(
  'Manage Invitation Error',
  props<{ status: string }>(),
);

export const manageCalendars = organizationsActions.create(
  'Manage Calendars',
  props<OrganizationInvitations>(),
);
export const manageCalendarsSuccess = organizationsActions.create('Manage Invitation Success');

export const removeOrganization = organizationsActions.create(
  'Remove Organization',
  props<{ organizationId: number }>(),
);

export const fetchRequiredActions = organizationsActions.create('Fetch Required Actions');
